module.exports = __webpack_public_path__ + "@/assets/img/sobre-teclab.75bbc212.svg";